/* Product cards share the cart API and drawer renderer: the drawer is rendered and opened only after the
   add resolves with fresh basket HTML; otherwise the basket page (server truth) is shown. */
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-quick-add-form]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  if (!button || button.disabled) return;
  const original = button.innerHTML;
  button.disabled = true;
  button.textContent = 'Adding…';
  try {
    const result = await window.Waggle.cart.add(new FormData(form));
    if (result.fresh && window.Waggle.settings.cartType === 'drawer' && document.getElementById('CartDrawer')) {
      window.Waggle.cart.render(result.sections);
      window.Waggle.overlays.open('CartDrawer', button);
    } else {
      window.location.assign(window.Waggle.routes.cart);
    }
    window.Waggle.announce('Added to basket');
  } catch (error) {
    const errorNode = form.querySelector('[role="alert"]') || document.createElement('span');
    errorNode.setAttribute('role', 'alert');
    errorNode.className = 'form-error';
    errorNode.textContent = error.message || 'Could not add to basket';
    form.append(errorNode);
  } finally {
    button.disabled = false;
    button.innerHTML = original;
  }
});
